// import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
const lange = window.localStorage.getItem('lange') ?? 'zh_CN';
window.localStorage.setItem('lange', lange)
i18n
    // .use(LanguageDetector)  //嗅探当前浏览器语言
    .use(initReactI18next) //init i18next
    .init({
        resources: {
            en_US: {
                translation: require('./en.json'),
            },
            zh_CN: {
                translation: require('./zh_CN.json'),
            },
            zh_HK: {
                translation: require('./zh_HK.json'),
            },
        },

        fallbackLng: lange,
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
